import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Subject} from "rxjs";
import {TaskI, TaskStatus} from "../../../../infrastructure/interfaces/task.interface";

@Component({
  selector: 'app-phi-viewer',
  templateUrl: './phi-viewer.component.html',
  styleUrls: ['./phi-viewer.component.scss']
})
export class PhiViewerComponent implements OnInit, OnDestroy{
  destroy$ = new Subject<void>();

  taskStatus = TaskStatus

  @Input() phiUrl: string | null = null;
  @Input() patientId: string | null = null;
  @Input() encounterId: string | null = null;
  @Input() phiSpecialty: string = '';
  @Input() officeId: string = '';
  @Input() modality: string = '';
  @Input() task: TaskI | null = null;

  constructor() {
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
